'use es6';

import PropTypes from 'prop-types';
import { Fragment } from 'react';
import createTrap from 'reporting-ui-components/trap/createTrap';
import ErrorMessage from 'reporting-ui-components/components/shared/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  Raise
} = createTrap('Error', ErrorMessage.propTypes.error);
export const RaiseError = props => {
  const {
    error,
    type
  } = props;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      "data-test-id": "error-boundary"
    }), /*#__PURE__*/_jsx(Raise, {
      value: {
        error,
        type
      },
      children: /*#__PURE__*/_jsx(ErrorMessage, Object.assign({}, props))
    })]
  });
};
RaiseError.propTypes = {
  type: ErrorMessage.propTypes.type,
  error: PropTypes.any.isRequired
};